import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withKeys as _withKeys, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "nge-team-invites",
  role: "alertdialog",
  "aria-label": "Session invitations"
}
const _hoisted_2 = { class: "nge-team-invite-title" }
const _hoisted_3 = { class: "nge-team-invite-text" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "nge-team-invite-note"
}
const _hoisted_6 = { class: "nge-team-invite-hint" }
const _hoisted_7 = { class: "nge-team-invite-actions" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onKeydown"]
const _hoisted_11 = { class: "nge-team-party-card" }
const _hoisted_12 = {
  class: "nge-team-party-burst",
  "aria-hidden": "true"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "nge-team-party-kicker" }, "Team cell complete", -1 /* HOISTED */)
const _hoisted_14 = { class: "nge-team-party-title" }
const _hoisted_15 = { class: "nge-team-party-mates" }
const _hoisted_16 = { class: "nge-team-party-text" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["aria-label"]
const _hoisted_19 = { class: "nge-team-head" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  class: "nge-team-live",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_21 = { class: "nge-team-title" }
const _hoisted_22 = { class: "nge-team-members" }
const _hoisted_23 = ["title"]
const _hoisted_24 = {
  key: 0,
  class: "nge-team-tag"
}
const _hoisted_25 = {
  key: 1,
  class: "nge-team-tag"
}
const _hoisted_26 = ["disabled", "onClick"]
const _hoisted_27 = ["aria-pressed", "title", "onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", {
  class: "nge-team-dot nge-team-dot--waiting",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */)
const _hoisted_29 = { class: "nge-team-name" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "nge-team-tag" }, "invited", -1 /* HOISTED */)
const _hoisted_31 = {
  key: 0,
  class: "nge-team-empty"
}
const _hoisted_32 = { class: "nge-team-invitebox" }
const _hoisted_33 = {
  key: 0,
  class: "nge-team-found"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 1,
  class: "nge-team-empty"
}
const _hoisted_36 = { class: "nge-team-chat" }
const _hoisted_37 = ["aria-expanded"]
const _hoisted_38 = {
  key: 0,
  class: "nge-team-chat-unread"
}
const _hoisted_39 = {
  class: "nge-team-chat-caret",
  "aria-hidden": "true"
}
const _hoisted_40 = {
  ref: "chatList",
  class: "nge-team-chat-list",
  role: "log",
  "aria-live": "polite"
}
const _hoisted_41 = {
  key: 0,
  class: "nge-team-empty"
}
const _hoisted_42 = ["placeholder", "maxlength", "onKeydown"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "nge-team-foot" }, "The cell, every annotation layer and where you are looking are shared with this session.", -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createCommentVNode(" An invitation waiting for an answer. "),
    ($setup.team.invites.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.team.invites, (inv) => {
            return (_openBlock(), _createElementBlock("div", {
              key: inv.room + inv.from.id,
              class: "nge-team-invite"
            }, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(inv.mode === 'mentor' ? 'Offer of help' : 'Team invitation'), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_3, [
                (inv.mode === 'mentor')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("b", null, _toDisplayString(inv.from.name), 1 /* TEXT */),
                      _createTextVNode(" would like to join your view and help.")
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("b", null, _toDisplayString(inv.from.name), 1 /* TEXT */),
                      _createTextVNode(" invites you to work on a cell together"),
                      ($setup.datasetName(inv.dataset))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " in " + _toDisplayString($setup.datasetName(inv.dataset)), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      _createTextVNode(".")
                    ], 64 /* STABLE_FRAGMENT */))
              ]),
              (inv.note)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(inv.note), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_6, _toDisplayString(inv.mode === 'mentor' ? 'They will see the cell and the marks in your view, and where you are looking.' : 'Your view will change to the team\'s cell. Marks you draw are shared with the team.'), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  type: "button",
                  class: "nge-team-btn nge-team-btn--go",
                  onClick: $event => ($setup.acceptInvite(inv))
                }, "Accept", 8 /* PROPS */, _hoisted_8),
                _createElementVNode("button", {
                  type: "button",
                  class: "nge-team-btn",
                  onClick: $event => ($setup.declineInvite(inv))
                }, "Decline", 8 /* PROPS */, _hoisted_9)
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" A saved team finished its cell. "),
    ($setup.celebrating)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "nge-team-party",
          role: "alertdialog",
          "aria-label": "Team cell complete",
          onKeydown: _withKeys($setup.closeCelebration, ["esc"])
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(14, (n) => {
                return _createElementVNode("i", {
                  key: n,
                  style: _normalizeStyle({ '--i': n })
                }, null, 4 /* STYLE */)
              }), 64 /* STABLE_FRAGMENT */))
            ]),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, _toDisplayString($setup.celebrating.title || 'You did it together'), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.celebrationMates, (m) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: m.id,
                  class: _normalizeClass(["nge-team-party-mate", { 'nge-team-party-mate--you': m.id === $setup.myId }])
                }, _toDisplayString(m.id === $setup.myId ? 'You' : m.name), 3 /* TEXT, CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createElementVNode("div", _hoisted_16, [
              ($setup.iCompletedIt)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("You completed the cell your team was working on. Everyone on the team gets it.")
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString($setup.completerName) + " completed the cell your team was working on. It counts for you too.", 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "nge-team-btn nge-team-btn--go",
              disabled: $setup.closingCelebration,
              onClick: $setup.closeCelebration
            }, "For science", 8 /* PROPS */, _hoisted_17)
          ])
        ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_10))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" The session strip. "),
    ($setup.team.room)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "nge-team-strip",
          role: "region",
          "aria-label": $setup.title
        }, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("span", _hoisted_21, _toDisplayString($setup.title), 1 /* TEXT */),
            _createElementVNode("button", {
              type: "button",
              class: "nge-team-btn nge-team-btn--leave",
              title: "Leave this session. Your own view stays as it is.",
              onClick: _cache[0] || (_cache[0] = $event => ($setup.leaveTeam()))
            }, "Leave")
          ]),
          _createElementVNode("ul", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.team.members, (m) => {
              return (_openBlock(), _createElementBlock("li", {
                key: m.id,
                class: "nge-team-member"
              }, [
                _createElementVNode("span", {
                  class: "nge-team-dot",
                  style: _normalizeStyle({ background: m.color }),
                  "aria-hidden": "true"
                }, null, 4 /* STYLE */),
                _createElementVNode("span", {
                  class: "nge-team-name",
                  title: m.name
                }, _toDisplayString(m.name), 9 /* TEXT, PROPS */, _hoisted_23),
                (m.id === $setup.myId)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, "you"))
                  : (m.id === $setup.team.leader && $setup.team.mode === 'mentor')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, "leading"))
                    : _createCommentVNode("v-if", true),
                (m.id !== $setup.myId)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "nge-team-mini",
                        disabled: !m.pos,
                        title: "Move your view to where they are",
                        onClick: $event => ($setup.jumpTo(m.id))
                      }, "Jump", 8 /* PROPS */, _hoisted_26),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["nge-team-mini", { 'nge-team-mini--on': $setup.team.following === m.id }]),
                        "aria-pressed": $setup.team.following === m.id ? 'true' : 'false',
                        title: $setup.team.following === m.id ? 'Stop following. Your view is yours again.' : 'Your view follows theirs as they move',
                        onClick: $event => ($setup.follow(m.id))
                      }, _toDisplayString($setup.team.following === m.id ? 'Following' : 'Follow'), 11 /* TEXT, CLASS, PROPS */, _hoisted_27)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.team.waiting, (w) => {
              return (_openBlock(), _createElementBlock("li", {
                key: 'w' + w.id,
                class: "nge-team-member nge-team-member--waiting"
              }, [
                _hoisted_28,
                _createElementVNode("span", _hoisted_29, _toDisplayString(w.name), 1 /* TEXT */),
                _hoisted_30
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          ($setup.team.members.length < 2 && !$setup.team.waiting.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, "Nobody else is here yet. Invite a player to begin."))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_32, [
            (!$setup.inviting)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "nge-team-btn",
                  onClick: _cache[1] || (_cache[1] = $event => ($setup.inviting = true))
                }, "+ Invite a player"))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.query) = $event)),
                    class: "nge-team-input",
                    placeholder: "Player name",
                    "aria-label": "Player to invite",
                    onKeydown: [
                      _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                      _cache[6] || (_cache[6] = _withKeys(_withModifiers($event => {$setup.inviting = false; $setup.query = ''}, ["stop"]), ["esc"]))
                    ],
                    onKeyup: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                    onKeypress: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_vModelText, $setup.query]
                  ]),
                  ($setup.found.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.found, (u) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: u.id,
                            type: "button",
                            class: "nge-team-found-item",
                            onClick: $event => ($setup.inviteUser(u))
                          }, _toDisplayString(u.username || u.display_name), 9 /* TEXT, PROPS */, _hoisted_34))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : ($setup.query.trim().length >= 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, "No player by that name."))
                      : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
          ]),
          _createCommentVNode(" Team chat. "),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("button", {
              type: "button",
              class: "nge-team-chat-head",
              "aria-expanded": $setup.chatOpen ? 'true' : 'false',
              onClick: _cache[7] || (_cache[7] = $event => ($setup.chatOpen = !$setup.chatOpen))
            }, [
              _createElementVNode("span", null, _toDisplayString($setup.team.mode === 'mentor' ? 'Help chat' : 'Team chat'), 1 /* TEXT */),
              (!$setup.chatOpen && $setup.team.unread)
                ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString($setup.team.unread), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("span", _hoisted_39, _toDisplayString($setup.chatOpen ? '▾' : '▸'), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_37),
            ($setup.chatOpen)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_40, [
                    (!$setup.team.chat.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, "Only the people in this session see what is said here. Nothing is saved."))
                      : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.team.chat, (c, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "nge-team-chat-line"
                      }, [
                        _createElementVNode("b", {
                          style: _normalizeStyle({ color: c.color })
                        }, _toDisplayString(c.by === $setup.myId ? 'You' : c.name), 5 /* TEXT, STYLE */),
                        _createTextVNode(),
                        _createElementVNode("span", null, _toDisplayString(c.text), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.chatText) = $event)),
                    class: "nge-team-input",
                    placeholder: $setup.team.mode === 'mentor' ? 'Message each other' : 'Message your team',
                    "aria-label": "Message this session",
                    maxlength: $setup.TEAM_CHAT_MAX,
                    enterkeyhint: "send",
                    onKeydown: [
                      _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
                      _withKeys(_withModifiers($setup.sayToTeam, ["prevent","stop"]), ["enter"])
                    ],
                    onKeyup: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
                    onKeypress: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_42), [
                    [_vModelText, $setup.chatText]
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          _hoisted_43
        ], 8 /* PROPS */, _hoisted_18))
      : _createCommentVNode("v-if", true)
  ]))
}